import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {DocumentField, FieldReturn} from '../../types'

export const document = (props: DocumentField, mergeProps?: Partial<DocumentField>): FieldReturn =>
  field('document', mergeConfig('document', props, mergeProps))
